module.exports = __webpack_public_path__ + "static/media/p_ocad.d52d5c6f.png";